<template>
  <div class="w-100%">

  <div>
  <el-row class="panel m-w-1280 header" id="right-menu">
    <el-col :span="24" class="panel-top">
      <el-col :span="4" style="text-align: center;width:180px;">
          <img v-if="logo_type == '1'" :src="img" class="logo h-50" style="max-width:140px;">
          <span v-else>{{title}}</span>
      </el-col>
      <el-col :span="16" class="ofv-hd">
        <el-menu
          class="el-menu-demo"
          mode="horizontal"
          background-color="#1F2D3D"
          text-color="#fff"
          active-text-color="#ffd04b">
          <el-menu-item v-for="(menu, index) in topMenu" :index="''+(index+1)+''" @click="switchTopMenu(menu)">{{menu.title}}</el-menu-item>
        </el-menu>
        <!-- <div class="fl p-l-20 p-r-20 top-menu" v-for="menu in topMenu" @click="switchTopMenu(menu)">{{menu.title}}</div> -->
      </el-col>
      <el-col :span="4" class="pos-rel">
        <el-button size="small" type="text" @click="suopinFormVisible=true" class="fr m-l-20" style="height:40px;line-height: 40px;color:#fff;">锁屏</el-button>
        <el-dropdown @command="handleMenu" class="fr" trigger="click">
          <span class="el-dropdown-link c-gra" style="cursor: pointer;color:#fff;">
            {{username}}&nbsp;&nbsp;<i class="fa fa-user" aria-hidden="true"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="changePwd">修改密码</el-dropdown-item>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-col>
    <el-col :span="24" class="panel-center">
      <!--<el-col :span="4">-->
      <aside class="w-182 ovf-hd" v-show="!showLeftMenu">
        <leftMenu :menuData="menuData" :menu="menu" ref="leftMenu"></leftMenu>
      </aside>
      <!--右边内容-->
      <section class="panel-c-c" :class="{'hide-leftMenu': hasChildMenu}">
        <div class="grid-content bg-purple-light">
          <el-col :span="24">
            <transition name="fade" mode="out-in" appear>
              <router-view v-loading="showLoading"></router-view>
            </transition>
          </el-col>
        </div>
      </section>
    </el-col>

    <el-dialog ref="dialog" :visible.sync="change_Pwd" custom-class="w-400 h-300" title="修改密码">
      <div class="ovf-auto">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="旧密码" prop="old_pwd">
            <el-input v-model.trim="form.old_pwd"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="new_pwd">
            <el-input v-model.trim="form.new_pwd"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="p-t-10">
        <el-button type="primary" size="small" class="fr m-r-20 m-b-20" :disabled="disable" @click="submit()">提交</el-button>
      </div>
    </el-dialog>
  </el-row>
  <el-dialog :visible.sync="suopinFormVisible" :show-close="suoping_password?false:true" :close-on-click-modal="suoping_password?false:true" :close-on-press-escape="suoping_password?false:true" style="background: #000;width: 100%;height: 100%;">
    <div class="h-200" v-if="suoping_password">
      <p style="text-align: center;font-size: 28px;"><b>主人暂时离开，请勿关机！</b></p>
      <p style="text-align: center;font-size: 28px;margin-top: 50px;"><el-input v-model="open_mima" :style="'width:'+(open_mima?'20%':'33%')+';'" placeholder="请输入解锁密码" @keyup.enter.native="jiesuo()" show-password auto-complete="new-password" type="password" clearable></el-input><el-button class="m-l-30" size="small" type="primary" @click="jiesuo()" v-if="open_mima"><i class="el-icon-unlock"></i> 解锁（回车）</el-button></p>
      <p style="text-align: center;font-size: 14px;">忘记解锁密码？<el-button type="text" style="color:#f00;font-size: 24px;" v-on:click="logout()">退出登录</el-button>后重新登录</p>
    </div>
    <div class="h-280" v-else>
      <p style="text-align: center;font-size: 28px;"><b>设置锁屏密码</b></p>
      <p style="text-align: center;font-size: 28px;margin-top: 50px;"><el-input v-model="sp_password" :style="'width:'+(sp_password?'20%':'33%')+';'" placeholder="请输入锁屏密码" @keyup.enter.native="suoping()" show-password auto-complete="new-password" clearable type="password"></el-input><el-button class="m-l-30" size="small" type="primary" @click="suoping()" v-if="sp_password"><i class="el-icon-lock"></i> 锁屏（回车）</el-button></p>
      <p style="text-align: center;font-size: 14px;margin-top: 50px;color:#f00;">请牢记锁屏密码，忘记后可重新登录自动关闭锁屏密码</p>
    </div>
  </el-dialog>
  </div>
  
  </div>
</template>
<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s
  }
  .el-button{
    margin-right: 5px;
    height:34.5px;
    line-height:15px;
    margin-bottom: 5px;
  }
  
  .el-button+.el-button{
    margin-left: 0px;
  }
  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
  .el-upload {
    width:300px;
    height:160px;
    border: #bbb 1px dashed;
    border-radius: 3%;
    background-color: #fff;
    text-align: center;
    color:#111 !important;
  } 
  .el-upload i{
    line-height: 100px;
    color:#27b487 !important;
    font-size: 66px;
  } 

  .panel {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
  }
  
  .panel-top {
    height: 60px;
    line-height: 60px;
    color: #fff;
  }
  
  .panel-center {
    /* background: #324057; */
    position: absolute;
    top: 60px;
    bottom: 0px;
    overflow: hidden;
  }
  
  .panel-c-c {
    background: #f1f2f7;
    position: absolute;
    right: 0px;
    top: 0px;
    bottom: 0px;
    left: 180px;
    overflow-y: scroll;
    padding: 20px;
  }
  
  .logout {
    background: url(../assets/images/logout_36.png);
    background-size: contain;
    width: 20px;
    height: 20px;
    float: left;
  }
  
  .logo {
    margin: 5px auto;
  }
  
  .tip-logout {
    float: right;
    margin-right: 20px;
    padding-top: 5px;
    cursor: pointer;
  }
  
  .admin {
    color: #c0ccda;
    text-align: center;
  }
  .hide-leftMenu {
    left: 0px;
  }
  .list_detail{
    background-color: antiquewhite;
    padding: 5px 5px;
    border: 1px solid #fff;
    border-radius: 10px;
  }
  .list_detail p{
    display: inline-block;
    width: 188px;
    text-align-last: justify;
    margin: 5px 0;
    font-size: 16px;
    font-weight: 600;
  }
  .list_detail img{
    width: 80px;
    height: 80px;
    margin:5px;
  }
  .list_detail .titles{
    font-size:18px;
    font-weight:600;
    color: deeppink;
  }
  
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .text_copy{
    margin-left: 10px;
    font-size: 15px;
  }
  .top-menu:hover{
    background-color:rgba(255,255,255,0.2);
    /* background:rgba(200, 54, 54, 0.1); */
	  /* opacity:0.8;  -moz-opacity:1;-khtml-opacity: 1; */
}
/* .top-menu{
	background-image: url(../assets/images/j.jpg) !important;
    background-repeat: no-repeat !important;
    background-size: 100% !important;
} */
  #right-menu {
    --size: '';
    --size2: '';
    --size3: '';
    --size4: '';
  }
  .form-pane{
    padding: 15px 0px 0px 0px;
    height:var(--size3);
    overflow-y:auto;
    overflow: scroll;
    border: 1px solid #ccc;
    margin-bottom: 12px;
  }
  .form-page{
    padding: 15px 0px 0px 0px;
    height:var(--size4);
    overflow-y:auto;
    overflow: scroll;
    border: 1px solid #ccc;
    margin-bottom: 12px;
  }
  .table_page{
    height:var(--size) !important;
    overflow: scroll;
  }
  .table_pane{
    height:var(--size2) !important;
    overflow: scroll;
  }
  /* .bodys{
    background-image: url("../assets/images/j.jpg");
    background-repeat: no-repeat;
  } */
  .header {
  color: #fff;
  line-height: 60px;
  }
  .yiguidang{
    position: absolute;
    width:88px;
    height:88px;
    text-align: center;
    border-radius: 50%;
    right:0px;
    top:0px;
    z-index: 90000000000000000;
    opacity: 0.5;
  }
  .success_status{
    color:#07C160;
  }
  .goon_status{
    color:#bb0;
  }
  .error_status{
    color:rgb(233, 3, 3);
  }
  .el-table__body{
    height:50px !important;
  }
  .el-table__body tbody,tr,td{
    height:50px !important;
    margin:0px !important;
    padding: 0px !important;
    line-height: 50px !important;
  }
  .el-table__body tbody td{
    padding-right: 10px !important;
  }
  .el-table__body tbody .el-button{
    margin:0px;
  }
  .el-table__body .el-table__cell{
    height:50px !important;
  }
  .action_more{
    font-size:25px;
    margin-left:7px;
    padding-top:20px;
  }
  .action_more_button{
    width:35px !important;
    height:35px !important;
    float: right;
  }
  .el-input__inner{
    margin:0px;
    height:34.5px;
  }
  .el-input__inner:hover { 
    border-color: #66d660 !important;
  }
  .el-input__inner:active { 
    border-color: #66d660 !important;
  }
  .el-input__inner:focus { 
    border-color: #66d660 !important;
  }
  .el-select:hover { 
    border-color: #66d660 !important;
  }
  .el-select:active { 
    border-color: #66d660 !important;
  }
  .el-select:focus { 
    border-color: #66d660 !important;
  }
  .el-input--suffix:hover { 
    border-color: #66d660 !important;
  }
  .el-input--suffix:active { 
    border-color: #66d660 !important;
  }
  .el-input--suffix:focus { 
    border-color: #66d660 !important;
  }
  .el-button{
    margin-right: 5px;
    height:34.5px;
    line-height:15px;
    margin-bottom: 5px;
  }
  .top_logo{
    width: 200px;
    white-space:nowrap;
    text-overflow:ellipsis;
    float: left;
  }
  .top_menu{
    margin-left: 40px;
    width:460px;
    float: left;
  }
  .top_mess{
    float: right;
    margin-right: 10px;
    width:380px;
  }
  .el-input-search{
    width:150px !important;
    height:34.5px !important;
  }
  .el-date-editor-search{
    width:250px !important;
  }
  
  .el-date-editor .el-input__icon{
    line-height: 26px !important;
  }
  .el-date-editor .el-range-input{
    line-height: 38px !important;
  }
  .el-date-editor .el-range-separator{
    line-height: 26px !important;
  }
  .el-input .el-input__inner{
    height:34.5px !important;
  }
  .el-icon-arrow-up{
    line-height: 30px;
  }
  .el-input .el-input__icon{
    line-height: 35px !important;
  }
  .el-checkbox__inner{
    border:1px solid #ddd !important;
  }
  .el-cascader-search{
    width:220px !important;
  }
</style>
<script>
  import leftMenu from './Common/leftMenu.vue'
  import http from '../assets/js/http'
  import Vue from 'vue'

  export default {
    data() {
      return {
        // setBackground: {
        //     backgroundImage: "url(" + require("../assets/images/j.jpg") + ")",
        //     backgroundRepeat: "no-repeat"
        // },
        username: '',
        topMenu: [],
        childMenu: [],
        menuData: [],
        suopinFormVisible:false,
        hasChildMenu: false,
        change_Pwd:false,
        menu: null,
        module: null,
        bg_color:'linear-gradient(to bottom,#764ba2,#667eea)',
        img: '',
        title: '',
        suoping_password:'',
        sp_password:'',
        open_mima:'',
        logo_type: null,
        form: {
          auth_key: '',
          old_pwd: '',
          new_pwd: ''
        },
        rules: {
          old_pwd: [
            { required: true, message: '请输入旧密码', trigger: 'blur' },
            { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }
          ],
          new_pwd: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      logout() {
        this.$confirm('确认退出吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          _g.openGlobalLoading()
          let data = {
            authkey: Lockr.get('authKey'),
            sessionId: Lockr.get('sessionId')
          }
          this.apiPost('admin/base/logout', data).then((res) => {
            _g.closeGlobalLoading()
            this.handelResponse(res, (data) => {
              Lockr.rm('menus')
              Lockr.rm('authKey')
              Lockr.rm('rememberKey')
              Lockr.rm('authList')
              Lockr.rm('userInfo')
              Lockr.rm('sessionId')
              Cookies.remove('rememberPwd')
              _g.toastMsg('success', '退出成功')
              setTimeout(() => {
                router.replace('/')
              }, 1500)
            })
          })
        }).catch(() => {

        })
      },
      switchTopMenu(item) {
        if (!item.child) {
          router.push(item.url)
        } else {
          router.push(item.child[0].child[0].url)
        }
      },
      handleMenu(val) {
        switch (val) {
          case 'logout':
            this.logout()
            break
          case 'changePwd':
            this.changePwd()
            break
        }
      },
      open() {
        this.$refs.dialog.open()
      },
      close() {
        this.$refs.dialog.close()
      },
      submit() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.disable = !this.disable
            this.apiPost('admin/base/setInfo', this.form).then((res) => {
              this.handelResponse(res, (data) => {
                _g.toastMsg('success', '修改成功')
                Lockr.rm('authKey')
                Lockr.rm('authList')
                Lockr.rm('sessionId')
                setTimeout(() => {
                  router.replace('/')
                }, 1500)
              }, () => {
                this.disable = !this.disable
              })
            })
          }
        })
      },
      changePwd() {
        this.change_Pwd = true
      },
      getTitleAndLogo() {
        this.apiPost('admin/base/getConfigs').then((res) => {
          this.handelResponse(res, (data) => {
            document.title = data.SYSTEM_NAME
            this.logo_type = data.LOGO_TYPE
            this.title = data.SYSTEM_NAME
            this.img = data.SYSTEM_LOGO
          })
        })
      },
      getUsername() {
        this.username = Lockr.get('userInfo').username
      },
      suoping(){
        Lockr.set('suoping_password', this.sp_password);
        this.suoping_password = Lockr.get('suoping_password');
        this.sp_password = '';
        this.suopinFormVisible = true;
      },
      jiesuo(){
        if(this.suoping_password.length==this.open_mima.length){
          if(this.suoping_password==this.open_mima){
            this.suopinFormVisible = false;
            Lockr.set('suoping_password')
            this.sp_password = '';
            this.suoping_password = '';
            this.open_mima = '';
          }else{
            _g.toastMsg('error', '密码错误')
          }
        }
      }
    },
    created() {
      // CSSStyleDeclaration.setProperty("--size",'900px');
      
      // this.$refs.mycolor.style.setProperty("--bcColor",'white');
      
      this.suoping_password = Lockr.get('suoping_password');
      if(this.suoping_password){
        this.suopinFormVisible = true;
      }
      this.form.auth_key = Lockr.get('authKey')
      this.getTitleAndLogo()
      let authKey = Lockr.get('authKey')
      let sessionId = Lockr.get('sessionId')
      if (!authKey || !sessionId) {
        _g.toastMsg('warning', '您尚未登录')
        setTimeout(() => {
          router.replace('/')
        }, 1500)
        return
      }
      Vue.prototype.uploadUrl = window.HOST + 'admin/upload'
      Vue.prototype.readUrl = window.HOST + 'read_file?url='
      Vue.prototype.downloadUrl = window.HOST + 'download_file?url='
      this.getUsername()
      let menus = Lockr.get('menus')
      this.menu = this.$route.meta.menu
      this.module = this.$route.meta.module
      this.topMenu = menus
      _(menus).forEach((res) => {
        if (res.module == this.module) {
          this.menuData = res.child
          res.selected = true
        } else {
          res.selected = false
        }
      })
      setTimeout(function(){
        var bodyheight = document.getElementById('right-menu').offsetHeight;
        Vue.prototype.setHeight = {
          page_height:bodyheight-220,
          pane_height:bodyheight-280,
        };
        var size3 = bodyheight-240;
        var size4 = bodyheight-190;
        document.getElementById('right-menu').style.setProperty("--size3",size3+'px',"important");
        document.getElementById('right-menu').style.setProperty("--size4",size4+'px',"important");
      },1000)
    },
    computed: {
      routerShow() {
        return store.state.routerShow
      },
      showLeftMenu() {
        this.hasChildMenu = store.state.showLeftMenu
        return store.state.showLeftMenu
      }
    },
    components: {
      leftMenu,
    },
    watch: {
      '$route' (to, from) {
        _(this.topMenu).forEach((res) => {
          if (res.module == to.meta.module) {
            res.selected = true
            if (!to.meta.hideLeft) {
              this.menu = to.meta.menu
              this.menuData = res.child
            }
          } else {
            res.selected = false
          }
        })
      }
    },
    mixins: [http]
  }
</script>



// WEBPACK FOOTER //
// Home.vue?7f026f21